import { render, staticRenderFns } from "./OverviewCampaignsTable.vue?vue&type=template&id=3b8be8d7"
import script from "./OverviewCampaignsTable.vue?vue&type=script&lang=js"
export * from "./OverviewCampaignsTable.vue?vue&type=script&lang=js"
import style0 from "./OverviewCampaignsTable.vue?vue&type=style&index=0&id=3b8be8d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports